// removed by extract-text-webpack-plugin
module.exports = {"RightColumn":"Transactions__RightColumn__UMVmj","DataTable":"Transactions__DataTable__2V8KQ","marginTop80":"Transactions__marginTop80__3IJXi","readOnly":"Transactions__readOnly__xqpWt","label":"Transactions__label__240p7","descriptionColumn":"Transactions__descriptionColumn__qnr-v","matchActions":"Transactions__matchActions__3SV6j","matchPosition":"Transactions__matchPosition__2t0ot","spinner":"Transactions__spinner__1SwTd","sk-bouncedelay":"Transactions__sk-bouncedelay__3mpLk","bounce1":"Transactions__bounce1__P5ov7","bounce2":"Transactions__bounce2__5x6f1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TransactionList/Transactions.css
// module id = 1619
// module chunks = 0